import {Buffer} from 'buffer';

/**
 * @desc encode string into base64
 * @param base64
 * @returns string
 */
const encodeIntoBase64 = (value: string | number) => {
    return Buffer.from(String(value)).toString('base64');
};

/**
 * @desc decode base64 into string
 * @param base64
 * @returns string
 */
const decodeFromBase64 = (base64: string) => {
    return Buffer.from(base64, 'base64').toString();
};

export {encodeIntoBase64, decodeFromBase64};
